import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRotatePdf24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#AA67FF" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.5 10.697s-1.495-2.093-2.71-3.342a6.6 6.6 0 0 0-4.746-2.022c-3.706 0-6.71 3.088-6.71 6.897 0 1.85.709 3.531 1.863 4.77M19.5 10.697V6.1m0 4.597h-4.474"
    />
    <path
      stroke="#fff"
      strokeDasharray="2 3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.667 13.667c-.863 2.888-3.62 5-6.888 5a7.35 7.35 0 0 1-3.112-.685"
    />
  </svg>
);
export default SvgRotatePdf24;
